import axios from "axios";
export const BASE_URL = 'http://210.56.27.19:8082';
export const myAxios = axios.create({
   baseURL: BASE_URL
});

export const FETCH_HE_URL = '/get_jazz_header?vinfo'
